module.exports = __webpack_public_path__ + "static/media/caret-red-left.84266f83.svg";